/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeesEmployeesEmployee } from './employees-employees-employee';

export interface TalentRecommendationApproval {
  id: string;
  talentRecommendationId: string;
  acknowledgedById?: string | null;
  acknowledgedAt?: string | null;
  reason?: string | null;
  isRequired: boolean;
  stepName: string | null;
  state: TalentRecommendationApprovalStateEnum;
  acknowledgedBy?: EmployeesEmployeesEmployee;
  createdById: string;
  createdAt: string;
  updatedById: string;
  updatedAt: string;
}
export enum TalentRecommendationApprovalStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
